export default __webpack_public_path__ + "static/media/detail_big_10_1.9a622da2.jpg";